export const buttonIds = {
  settings: "waitsigns-settings",
  getStartedButton: "waitsigns-get-started-button",
  homeButton: "waitsigns-home-button",
  bottomBar: {
    resort: "waitsigns-bottombar-resort",
  },
};
